/* eslint-disable max-len, no-nested-ternary, consistent-return */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid/v1';
import { Bert } from 'meteor/themeteorchef:bert';
import { ButtonToolbar, ButtonGroup, Button, Row, Col, Form, Modal } from 'react-bootstrap';
import { isNil, isEmpty, isEqual, map, cloneDeep, isNaN } from 'lodash';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as annotationOps from '../../../api/Annotations/annotation-operations';
import * as mapOps from '../../../api/Maps/map-operations';
import * as templateOps from '../../../api/AnnotationTemplates/annotation-template-operations';
import * as videoOps from '../../../api/Videos/video-operations';
import { LIBRARY_ICON_TYPES } from '../../../api/AnnotationTemplates/AnnotationTemplates';

import PageHeader from '../../atoms/PageHeader';
import AnnotationTemplatePreview from '../../components/AnnotationTemplatePreview';
import BlankState from '../../components/BlankState';
import NotFound from '../NotFound';
import methodPromise from '../../../modules/method-promise-wrapper';
import handleErrorInClient from '../../../modules/handle-error-in-client';
import { exportTextToLocalFile } from '../../../modules/export-import-files';

import ShowListIconsFontawesome from '../../components/ShowListIconsFontawesome/index';

class ViewAnnotationTemplate extends Component {
  state = {
    previewMode: this.props.startingPreviewMode,
    openModal: false,
    openInfoAnnotation: false,
    isEditActive: false,
    indexEditInfo: -1,
    arrayInfoAnnotation: [],
    stateNameTemplate: templateOps.getName(this.props.annotationTemplate)
  };

  componentDidUpdate(prevProps) {
    const { annotationTemplate, isCreateTemplate } = this.props;
    const { annotationTemplate: prevAnnotationTemplate } = prevProps;
    if (!isEqual(annotationTemplate, prevAnnotationTemplate) && !isCreateTemplate) {
      this.handleNameTemplate(templateOps.getName(annotationTemplate));
    }
  }

  updateValuesInfo = value => {
    if (isNaN(value)) {
      Bert.alert('Invalid value', 'danger');
    } else {
      const { arrayInfoAnnotation, indexEditInfo } = this.state;
      const newArrayInfoAnnotation = map(arrayInfoAnnotation, (element, index) => {
        const cloneElement = cloneDeep(element);
        if (index === indexEditInfo) {
          cloneElement.value = value;
        }
        return cloneElement;
      });
      this.setState({ arrayInfoAnnotation: newArrayInfoAnnotation });
    }
  };

  changeToPreviewMode = () => {
    this.setState({ previewMode: 'preview' });
  };

  changeToEditionMode = () => {
    this.setState({ previewMode: 'edition' });
  };

  setOpenModal = value => this.setState({ openModal: value });

  setCloseInfoAnnotation = () => this.setState({ openInfoAnnotation: false, isEditActive: false });

  handleCancelEdit = () => this.setState({ isEditActive: false });

  handleEditInfo = index => this.setState({ isEditActive: true, indexEditInfo: index });

  handleNameTemplate = value => {
    const { updatedAnnotation, annotationTemplate, updateAnnotationSelected } = this.props;
    if (!isEmpty(updatedAnnotation) && !isEmpty(annotationTemplate)) {
      const newAnnotation = cloneDeep(updatedAnnotation);
      const newAnnotationTemplate = cloneDeep(annotationTemplate);
      newAnnotationTemplate.name = value;
      newAnnotation.geoJSON.properties.template = newAnnotationTemplate;
      this.setState({ stateNameTemplate: value });
      updateAnnotationSelected(newAnnotation);
    }
  };

  openSelectFile = () => {
    const newInput = document.createElement('input');
    newInput.type = 'file';
    newInput.onchange = this.importInfoAnnotation;
    newInput.click();
  };

  handleIconSelected = (elementIcon, library) => {
    const { updatedAnnotation, annotationTemplate, updateAnnotationSelected } = this.props;
    const newAnnotation = cloneDeep(updatedAnnotation);
    const newAnnotationTemplate = cloneDeep(annotationTemplate);
    if (library === LIBRARY_ICON_TYPES.FONTAWESOME) {
      newAnnotationTemplate.icon = elementIcon;
      newAnnotationTemplate.libraryIcon = library;
    }

    if (library === LIBRARY_ICON_TYPES.SVG) {
      newAnnotationTemplate.icon = elementIcon.name;
      newAnnotationTemplate.iconSvg = elementIcon.url;
      newAnnotationTemplate.libraryIcon = library;
      newAnnotationTemplate.categorySvg = elementIcon.category;
    }
    if (!isEmpty(newAnnotation)) {
      newAnnotation.geoJSON.properties.template = newAnnotationTemplate;
      updateAnnotationSelected(newAnnotation);
    }
  };

  saveInfoAnnotation = async () => {
    const {
      changeVideoContainerStateProperty,
      MapProps,
      updatedAnnotation,
      updateAnnotationSelected,
      video
    } = this.props;
    const { arrayInfoAnnotation } = this.state;
    const geoJsonAnnotation = annotationOps.getGeoJSON(updatedAnnotation);
    const { geometry, properties } = geoJsonAnnotation;
    const { videoPosition, videoTime } = properties;
    let newVideoTime = videoTime;
    let newIsProyected = annotationOps.getIsProyectedPoint(updatedAnnotation);
    map(arrayInfoAnnotation, element => {
      switch (element.nameSchema) {
        case 'coordinates[0]':
          geometry.coordinates[0] = element.value;
          break;
        case 'coordinates[1]':
          geometry.coordinates[1] = element.value;
          break;
        case 'x':
          videoPosition.x = element.value;
          break;
        case 'y':
          videoPosition.y = element.value;
          break;
        case 'width':
          videoPosition.width = element.value;
          break;
        case 'height':
          videoPosition.height = element.value;
          break;
        case 'videoTime':
          newVideoTime = element.value * 1e6;
          break;
        default:
          break;
      }
    });
    const coordsAnnotation = annotationOps.getCoordinates(updatedAnnotation);
    if (!isEqual(videoTime, newVideoTime) && isEqual(coordsAnnotation, geometry.coordinates)) {
      newIsProyected = false;
    }
    const newAnnotation = {
      geoJSON: {
        type: 'Feature',
        geometry,
        properties: {
          video: videoOps.getId(video),
          videoTime: newVideoTime,
          videoPosition,
          template: annotationOps.getTemplate(updatedAnnotation),
          isProyected: newIsProyected
        }
      },
      origin: annotationOps.getOrigin(updatedAnnotation),
      isTracking: false // teide cambiar según la anotación anterior.
    };
    let newId = '';
    const isValid =
      MapProps && !isEmpty(mapOps.getSharedConfiguration(MapProps.map))
        ? mapOps.getSharedConfiguration(MapProps.map).deleteAnnotations
        : false;
    try {
      await methodPromise(
        'annotations.hardDelete',
        annotationOps.getId(updatedAnnotation),
        isValid
      );
      newId = await methodPromise('annotations.insert', newAnnotation);
      Bert.alert('Annotation updated', 'success');
    } catch (error) {
      handleErrorInClient(error);
    }

    if (!isEmpty(newId)) {
      updateAnnotationSelected(newAnnotation);
    }
    changeVideoContainerStateProperty('videoTime', newVideoTime);
    this.setCloseInfoAnnotation();
  };

  setOpenInfoAnnotation = () => {
    const { updatedAnnotation } = this.props;
    const annotationGeoJson = annotationOps.getGeoJSON(updatedAnnotation);
    const { coordinates } = annotationGeoJson.geometry;
    const { videoTime, videoPosition } = annotationGeoJson.properties;
    const { x, y, width, height } = videoPosition;
    const infoAnnotation = [
      {
        nameInfo: 'Latitude',
        value: coordinates[1],
        nameSchema: 'coordinates[1]'
      },
      {
        nameInfo: 'Longitude',
        value: coordinates[0],
        nameSchema: 'coordinates[0]'
      },
      {
        nameInfo: 'Marker video width',
        value: width,
        nameSchema: 'width'
      },
      {
        nameInfo: 'Marker video height',
        value: height,
        nameSchema: 'height'
      },
      { nameInfo: 'Marker position X ', value: x, nameSchema: 'x' },
      { nameInfo: 'Marker position  Y ', value: y, nameSchema: 'y' },

      { nameInfo: 'Time', value: videoTime * 1e-6, nameSchema: 'videoTime' }
    ];
    this.setState({ openInfoAnnotation: true, arrayInfoAnnotation: infoAnnotation });
  };

  exportInfoAnnotation = () => {
    const { updatedAnnotation, video } = this.props;
    const { arrayInfoAnnotation } = this.state;
    const nameFile = `InfoAnnotation_${templateOps.getName(
      annotationOps.getTemplate(updatedAnnotation)
    )}_${videoOps.getName(video)}.json`;
    exportTextToLocalFile(
      nameFile,
      JSON.stringify({ infoAnnotation: arrayInfoAnnotation }, null, '  ')
    );
  };

  importInfoAnnotation = event => {
    const file = event.target.files[0];
    const fileReader = new FileReader();
    fileReader.readAsText(file);
    fileReader.onload = async () => {
      const { result } = fileReader;
      const parsedText = JSON.parse(result);
      const fileImport = parsedText[0];
      const annotationImport = isEmpty(fileImport) ? parsedText : fileImport;
      const { infoAnnotation } = annotationImport;
      this.setState({ arrayInfoAnnotation: infoAnnotation });
    };
    fileReader.onerror = () => {
      Bert.alert('Error on load file', 'danger');
    };
  };

  render() {
    const {
      annotationTemplate,
      selectedTemplate,
      updateAnnotationFields,
      trashAnnotationTemplate,
      history,
      match,
      readOnly,
      isNotesComponent,
      height,
      isShowButtons,
      isConnectionTemplate,
      isCreateTemplate
    } = this.props;
    const {
      previewMode,
      openModal,
      openInfoAnnotation,
      arrayInfoAnnotation,
      isEditActive,
      indexEditInfo,
      stateNameTemplate
    } = this.state;
    const libraryIcons = templateOps.getLibraryIcon(annotationTemplate);
    if (selectedTemplate === '') {
      return <BlankState title="No template selected" subtitle="Please select a template" />;
    }
    if (selectedTemplate !== '' && isEmpty(annotationTemplate)) {
      return <NotFound />;
    }
    return (
      <>
        <Row>
          <Col xs={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <PageHeader>
              {isShowButtons && (
                <ButtonToolbar>
                  <ButtonGroup size="sm" className="mr-2">
                    <Button
                      onClick={this.changeToPreviewMode}
                      variant="info"
                      active={previewMode === 'preview'}
                    >
                      Preview
                    </Button>
                    <Button
                      onClick={this.changeToEditionMode}
                      active={previewMode === 'edition'}
                      variant="info"
                    >
                      Edition
                    </Button>
                  </ButtonGroup>
                  {!readOnly && (
                    <ButtonGroup size="sm">
                      <Button
                        onClick={() =>
                          history.push(`${match.url}/${templateOps.getId(annotationTemplate)}/edit`)
                        }
                      >
                        Edit
                      </Button>
                      <Button
                        onClick={() =>
                          trashAnnotationTemplate(templateOps.getId(annotationTemplate))
                        }
                        variant="danger"
                      >
                        Delete
                      </Button>
                    </ButtonGroup>
                  )}
                </ButtonToolbar>
              )}
            </PageHeader>
          </Col>
        </Row>
        <Row>
          <Col xs={12} style={{ height, overflow: 'auto' }}>
            {previewMode === 'edition' && (
              <>
                <Row>
                  {!isCreateTemplate && (
                    <>
                      <Form.Control
                        type="text"
                        style={{
                          marginTop: '2%',
                          marginBottom: '2%',
                          marginRight: '1%',
                          width: '60%',
                          marginLeft: !isNotesComponent ? '0%' : '4%'
                        }}
                        name={`${templateOps.getName(annotationTemplate)}-name`}
                        value={stateNameTemplate}
                        onChange={event => this.setState({ stateNameTemplate: event.target.value })}
                        onBlur={event => this.handleNameTemplate(event.target.value)}
                      />

                      <Button
                        style={{ marginTop: '2%', marginBottom: '2%', maxHeight: '40px' }}
                        variant="outline-primary"
                        onClick={() => this.setOpenModal(true)}
                      >
                        {libraryIcons === LIBRARY_ICON_TYPES.FONTAWESOME && (
                          <FontAwesomeIcon icon={templateOps.getIcon(annotationTemplate)} />
                        )}
                        {libraryIcons === LIBRARY_ICON_TYPES.SVG && (
                          <img
                            src={templateOps.getIconSvg(annotationTemplate)}
                            alt={templateOps.getIcon(annotationTemplate)}
                            style={{
                              marginRight: '5px',
                              width: '20px',
                              height: '20px',
                              marginTop: '0%',
                              marginBottom: '0%'
                            }}
                          />
                        )}
                      </Button>
                      <Button
                        style={{ marginTop: '2%', marginBottom: '2%', maxHeight: '40px' }}
                        variant="outline-primary"
                        onClick={() => this.setOpenInfoAnnotation()}
                      >
                        <FontAwesomeIcon icon="info" />
                      </Button>
                      <ShowListIconsFontawesome
                        openModal={openModal}
                        setOpenModal={this.setOpenModal}
                        handleIconSelected={this.handleIconSelected}
                        selectedIcon={templateOps.getIcon(annotationTemplate)}
                        startLibrary={templateOps.getLibraryIcon(annotationTemplate)}
                        svg={templateOps.getIconSvg(annotationTemplate)}
                        startCategorySvg={templateOps.getCategorySvg(annotationTemplate)}
                      />
                    </>
                  )}
                  <Modal
                    show={openInfoAnnotation}
                    onHide={() => this.setCloseInfoAnnotation()}
                    size="lg"
                  >
                    <Modal.Header>
                      <Modal.Title>{templateOps.getName(annotationTemplate)}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <Form style={{ marginleft: '20%' }}>
                        {!isEmpty(arrayInfoAnnotation) && (
                          <>
                            {map(arrayInfoAnnotation, (element, index) => {
                              return (
                                <Row key={uuid()} style={{ marginleft: '20%' }}>
                                  <Col key={uuid()} alignitems="left">
                                    {element.nameInfo}
                                  </Col>

                                  {(!isEditActive || indexEditInfo !== index) && (
                                    <Col key={uuid()}>{element.value}</Col>
                                  )}
                                  {isEditActive && indexEditInfo === index && (
                                    <Col key={uuid()} alignitems="center">
                                      <Form.Control
                                        size="sm"
                                        type="text"
                                        name="valueInfo"
                                        defaultValue={element.value}
                                        onBlur={event =>
                                          this.updateValuesInfo(Number(event.target.value))
                                        }
                                      />
                                    </Col>
                                  )}
                                  <Col key={uuid()} alignitems="right">
                                    <Button
                                      key={uuid()}
                                      size="sm"
                                      variant={
                                        isEditActive && indexEditInfo === index
                                          ? 'outline-success'
                                          : 'outline-primary'
                                      }
                                      onClick={
                                        isEditActive && indexEditInfo === index
                                          ? () => this.handleCancelEdit()
                                          : () => this.handleEditInfo(index)
                                      }
                                    >
                                      {isEditActive && indexEditInfo === index
                                        ? 'close edit'
                                        : 'edit value'}
                                    </Button>
                                  </Col>
                                </Row>
                              );
                            })}
                          </>
                        )}
                      </Form>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button variant="outline-primary" onClick={() => this.exportInfoAnnotation()}>
                        <FontAwesomeIcon icon="upload" /> Export Json
                      </Button>
                      <Button variant="outline-primary" onClick={() => this.openSelectFile()}>
                        <FontAwesomeIcon icon="download" /> Import Json
                      </Button>

                      <Button variant="danger" onClick={() => this.setCloseInfoAnnotation()}>
                        Close
                      </Button>
                      <Button variant="success" onClick={() => this.saveInfoAnnotation()}>
                        Save Changes
                      </Button>
                    </Modal.Footer>
                  </Modal>
                </Row>
              </>
            )}
            {!isConnectionTemplate && (
              <AnnotationTemplatePreview
                annotationTemplate={annotationTemplate}
                updateAnnotationFields={updateAnnotationFields}
                previewMode={previewMode}
                {...this.props}
              />
            )}
          </Col>
        </Row>
      </>
    );
  }
}

ViewAnnotationTemplate.defaultProps = {
  annotationTemplate: {},
  changeVideoContainerStateProperty: () => {},
  height: '60vh',
  history: {},
  isConnectionTemplate: false,
  isCreateTemplate: false,
  isNotesComponent: false,
  isShowButtons: true,
  MapProps: {},
  match: {},
  updatedAnnotation: {},
  video: {},
  updateAnnotationFields: () => console.error('no action to update'),
  updateAnnotationSelected: () => {},
  readOnly: false,
  startingPreviewMode: 'preview',
  trashAnnotationTemplate: () => console.error('no action to delete')
};

ViewAnnotationTemplate.propTypes = {
  annotationTemplate: PropTypes.object,
  changeVideoContainerStateProperty: PropTypes.func,
  height: PropTypes.string,
  isNotesComponent: PropTypes.bool,
  isConnectionTemplate: PropTypes.bool,
  isCreateTemplate: PropTypes.bool,
  isShowButtons: PropTypes.bool,
  MapProps: PropTypes.object,
  readOnly: PropTypes.bool,
  selectedTemplate: PropTypes.string.isRequired,
  startingPreviewMode: PropTypes.string,
  updateAnnotationFields: PropTypes.func,
  updateAnnotationSelected: PropTypes.func,
  updatedAnnotation: PropTypes.object,
  video: PropTypes.object,
  trashAnnotationTemplate(props, propName, componentName) {
    if (
      props.readOnly === false &&
      (isNil(props[propName]) || typeof props[propName] !== 'function')
    ) {
      return new Error(`Please provide a trashAnnotationTemplate function in ${componentName}!`);
    }
  },
  history(props, propName, componentName) {
    if (
      props.readOnly === false &&
      (isNil(props[propName]) || typeof props[propName] !== 'object')
    ) {
      return new Error(`Please provide a history object in ${componentName}!`);
    }
  },
  match(props, propName, componentName) {
    if (
      props.readOnly === false &&
      (isNil(props[propName]) || typeof props[propName] !== 'object')
    ) {
      return new Error(`Please provide a march object in ${componentName}!`);
    }
  }
};

export default ViewAnnotationTemplate;
